import React from 'react'

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-gray-300'>
        <div className='flex flex-col justify-center items-center w-full h-full'>
            <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
                <div className='sm:text-right pb-4 pl-4'>
                    <p className='text-4xl font-bold inline border-b-4 border-[#ff914d]'>About</p>
                </div>
                <div></div>
            </div>

            <div className='max-w-[1000px] w-full sm:grid grid-cols-2 gap-8 px-4'>
                <div className='sm:text-right text-4xl font-bold '>
                    <p>Hi, I'm Rifadh, nice to meet you. Please take a moment to explore.</p>
                </div>
                <div>
                    <p>As an undergraduate from SLIIT with a passion for full stack development, I am dedicated to creating intuitive web applications. My goal is to deliver high-quality solutions using best coding practices. I am always willing to take on new challenges and stay current with the latest technologies.</p>
                </div>
            </div>

            </div>
      
    </div>
  )
}

export default About
